export const FREE_SPINS_REMAINING = "FREE_SPINS_REMAINING";

export const updateFreeSpinsGames = (freeSpinsGames) => ({
    type: FREE_SPINS_REMAINING,
    freeSpinsGames,
});
